import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
// import { Alert } from "../../components/Alert";
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Button, ImageListItem, Stack, Typography } from '@mui/material';
import AlertBox from '../../components/AlertBox/AlertBox';
import Spinner from '../../components/Spinner/Spinner';
import { useParams } from 'react-router-dom';
import { resetPassword } from '../../store/actions/actions';

const DemoPaper = styled(Paper)(({ theme, width, height }) => ({
  width: width,
  height: height,
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: "center"


}));

const ResetPassword = (props) => {
  // console.log("breakPointsData", props.breakPointsData)

  const { greaterThan768, greaterthan375, responsiveData } = props.breakPointsData;

  const [showPassword, setShowPassword] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [passChangeSuccess, setPassChangeSuccess] = useState(false);
  const [focus, setFocus] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const [passwordRules, setPasswordRules] = useState(
    {
      "newPassword": [
        { "title": "At least one Number", "color": "inherit" },
        { "title": "At least one Lowercase Character", "color": "inherit" },
        { "title": "At least one Uppercase Character", "color": "inherit" },
        { "title": "8 characters minimum", "color": "inherit" }
      ],
      "confirmPassword": [

        { "title": "At least one Number", "color": "inherit" },
        { "title": "At least one Lowercase Character", "color": "inherit" },
        { "title": "At least one Uppercase Character", "color": "inherit" },
        { "title": "8 characters minimum", "color": "inherit" }

      ]
    }
  )

  const { guid } = useParams();


  const handleClickShowPassword = () => setShowPassword((show) => !show);



  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleModalClose = () => {
    setPassChangeSuccess(false);
  };

  const renderModal = () => {
    const onClick = () => {
      setPassChangeSuccess(false);
      window.location.href = 'https://pdfeditor.heycarter.co.za/login';
    };

    return (
      <AlertBox
        isOpen={passChangeSuccess}
        onClose={handleModalClose}
        breakPointsData={props.breakPointsData}
        handleSubmit={onClick}
        title="Password Reset"
        text={`${successMessage}`}
        submitButtonText="Done"
        status={successMessage.includes("unsuccessful") ? "error" : "success"}
      />
    );
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    let updateRule;

    if (name === "newPassword") {
      setNewPassword(value);
      updateRule = checkPasswordRulesAndUpdateColors(value, passwordRules.newPassword);
      setPasswordRules({
        ...passwordRules,
        "newPassword": updateRule
      })
      const isValid = isPageValid(updateRule, passwordRules.confirmPassword, value, confirmPassword);
      setIsValid(isValid);

      if (confirmPassword.length > 0 && confirmPassword !== value) {
        setError("Passwords do not match");
      } else {
        setError("");
      }

    }

    if (name === "confirmPassword") {
      setConfirmPassword(value);
      updateRule = checkPasswordRulesAndUpdateColors(value, passwordRules.confirmPassword);
      setPasswordRules({
        ...passwordRules,
        "confirmPassword": updateRule
      })
      const isValid = isPageValid(passwordRules.newPassword, updateRule, newPassword, value)
      setIsValid(isValid);
      if (newPassword.length > 0 && newPassword !== value) {
        setError("Passwords do not match");
      } else {
        setError("");
      }
    }

  }

  const isPageValid = (newPassWordRules, confirmPasswordRules, newPassword, confirmPassword) => {
    const NewPassPAsswordRulesValid = newPassWordRules.every(element => element.color !== "inherit");
    const ConfirmPassWordRulesValid = confirmPasswordRules.every(element => element.color !== "inherit");
    const iaValid = NewPassPAsswordRulesValid && ConfirmPassWordRulesValid && (newPassword === confirmPassword);
    return iaValid;
  }

  const checkPasswordRulesAndUpdateColors = (password, rules) => {
    // Regular expressions for the rules
    const hasNumber = /\d/;
    const hasLowercase = /[a-z]/;
    const hasUppercase = /[A-Z]/;
    const minLength = 8;

    // Check each rule and update color if the rule is met
    rules.forEach(rule => {
      if (rule.title === "At least one Number") {
        rule.color = hasNumber.test(password) ? "#2196f3" : "inherit";
      } else if (rule.title === "At least one Lowercase Character") {
        rule.color = hasLowercase.test(password) ? "#2196f3" : "inherit";
      } else if (rule.title === "At least one Uppercase Character") {
        rule.color = hasUppercase.test(password) ? "#2196f3" : "inherit";
      } else if (rule.title === "8 characters minimum") {
        rule.color = password.length >= minLength ? "#2196f3" : "inherit";
      }
    });
    return rules;
  }




  const handleSubmit = async () => {
    setIsSubmitting(true);
    const payload = {
      "Guid": guid,
      "Password": newPassword
    }
    const response = await resetPassword(payload);
    if (response === "success") {
      setSuccessMessage("Your password was changed successfully");
      setIsSubmitting(false);
      setPassChangeSuccess(true);
      resetForm();
    } else {
      setSuccessMessage("The password change was unsuccessful. User not found or request expired.");
      setIsSubmitting(false);
      setPassChangeSuccess(true);
      resetForm();
    }
    // setTimeout(async () => {
    //   setIsSubmitting(false);S
    //   setPassChangeSuccess(true);
    //   resetForm();
    // }, 1000);
  };

  const handleFocus = (event) => {
    // console.log('Input field is focused', event.target.name);

    setFocus(event.target.name)
    // Add any additional logic you want to execute on focus here
  };

  const resetForm = () => {
    setPasswordRules(
      {
        "newPassword": [
          { "title": "At least one Number", "color": "inherit" },
          { "title": "At least one Lowercase Character", "color": "inherit" },
          { "title": "At least one Uppercase Character", "color": "inherit" },
          { "title": "8 characters minimum", "color": "inherit" }
        ],
        "confirmPassword": [

          { "title": "At least one Number", "color": "inherit" },
          { "title": "At least one Lowercase Character", "color": "inherit" },
          { "title": "At least one Uppercase Character", "color": "inherit" },
          { "title": "8 characters minimum", "color": "inherit" }

        ]
      }
    );
    setShowPassword(false);
    setIsValid(false);
    setIsSubmitting(false);
    //setPassChangeSuccess(false);
    setFocus("");
    setNewPassword("");
    setConfirmPassword("");
    setError("");
  }

  const ulStyles = {
    opacity: 0,
    transition: 'opacity 1s ease-in-out',
    ...(focus === 'confirmPassword' && {
      opacity: 1,
    })
  };

  // console.log("newPassword-----------------------------", newPassword);
  // console.log("passwordRules confirmPassword-----------", passwordRules["confirmPassword"]);
  // console.log("passwordRules New Password-----------", passwordRules["newPassword"]);

  return (

    <Box sx={{ width: props?.breakPointsData?.responsiveData?.paperWidth }}>

      {isSubmitting ? (
        <Spinner />
      ) : (
        <DemoPaper square={false} width={props?.breakPointsData?.responsiveData?.paperWidth} height={props?.breakPointsData?.responsiveData?.paperHeight} elevation={13} >

          <Stack sx={{ p: 2, height: '100%', width: `${props?.breakPointsData?.responsiveData?.formWidth}` }}
            direction="column"
            justifyContent="space-around"
            alignItems="center"

            spacing={props?.breakPointsData?.greaterthan375 ? 1 : 1}
          >
            <ImageListItem sx={{
              // bottom: props?.breakPointsData?.greaterthan375 ? '20rem' : '15rem',
              width: props?.breakPointsData?.greaterthan375 ? '12rem' : '10rem',
              // position: 'absolute'
            }}>
              <img
                src={`/ResetPassword.jpeg`}
                srcSet={`/ResetPassword.jpeg`}
                alt={'Breakfast'}
                loading="lazy"
              />
            </ImageListItem>


            <Stack >

              <FormControl fullWidth variant="standard">
                <InputLabel sx={{ fontSize: responsiveData.fontSize }} htmlFor="standard-adornment-password">New Password</InputLabel>
                <Input
                  sx={{ fontSize: responsiveData.fontSize }}
                  id="standard-adornment-password"
                  type={showPassword ? 'text' : 'password'}
                  onFocus={handleFocus} // Add the onFocus event listener here
                  name="newPassword"
                  value={newPassword}
                  onChange={handleChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>

                    </InputAdornment>
                  }
                />
                {focus === 'newPassword' && (
                  <ul style={{ textAlign: 'left', padding: '1rem' }}>
                    {passwordRules.newPassword.map((element, index) => (
                      <li style={{ color: `${element.color}` }} key={index}>{element.title}</li>
                    ))}
                  </ul>
                )}
              </FormControl>




              <FormControl fullWidth variant="standard">
                <InputLabel sx={{ fontSize: responsiveData.fontSize }} htmlFor="standard-adornment-password">Confirm Password</InputLabel>
                <Input
                  sx={{ fontSize: responsiveData.fontSize }}
                  id="standard-adornment-password"
                  name="confirmPassword"
                  type={showPassword ? 'text' : 'password'}
                  onFocus={handleFocus} // Add the onFocus event listener here
                  value={confirmPassword}
                  onChange={handleChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                {error && <FormHelperText error>{error}</FormHelperText>}

                {focus === 'confirmPassword' && (
                  <ul style={{ ...ulStyles, textAlign: 'left', padding: '1rem' }}>
                    {passwordRules.confirmPassword.map((element, index) => (
                      <li style={{ color: `${element.color}` }} key={index}>
                        {element.title}
                      </li>
                    ))}
                  </ul>
                )}

              </FormControl>

            </Stack>
            <Button
              onClick={handleSubmit}
              variant="contained"
              sx={{ mt: '10rem' }}
              disabled={Boolean(!isValid || isSubmitting)}
              //disabled={false}
              size={responsiveData.buttonSize}>RESET PASSAWORD</Button>

          </Stack>
        </DemoPaper>
      )
      }



      {renderModal()}
    </Box >

  )
}

export default ResetPassword